import { defineSlotRecipe } from '@chakra-ui/react';
import { comboboxAnatomy } from '@chakra-ui/react/anatomy';

export const comboBoxSlotRecipe = defineSlotRecipe({
	slots: comboboxAnatomy.keys(),
	base: {
		root: {
			gap: '2'
		},
		label: {
			fontWeight: 'semibold',
			textStyle: 'sm'
		},
		input: {
			bg: { base: 'white', _dark: '{colors.neutral.800}' },
			color: { base: '{colors.neutral.800}', _dark: 'white' },
			borderWidth: '1px',
			borderColor: { base: '{colors.neutral.300}', _dark: '{colors.neutral.600}' },
			borderRadius: 'md',
			height: '10',
			_focus: {
				outline: 'none',
				borderWidth: '1px',
				borderColor: { base: '{colors.blue.500} !important', _dark: '{colors.blue.400} !important' },
			},
			outlineWidth: '0px !important',
			_placeholder: {
				color: { base: '{colors.neutral.300}', _dark: '{colors.neutral.500}' },
			},
			_open: {
				borderColor: { base: '{colors.blue.500} !important', _dark: '{colors.blue.400} !important' },
			}
		},
		control: {
			bg: { base: 'white', _dark: '{colors.neutral.800}' },
			borderRadius: 'md',
			borderColor: { base: '{colors.neutral.300}', _dark: '{colors.neutral.600}' },
			h: '10',
		},
		indicatorGroup: {
			color: { base: '{colors.neutral.800}', _dark: 'white' }
		}
	},
	variants: {
		variant: {
			borderLeftRadiusNone: {
				input: {
					borderTopRightRadius: 'md',
					borderBottomRightRadius: 'md',
					borderTopLeftRadius: '0',
					borderBottomLeftRadius: '0',
				}
			},
			borderTransparent: {
				input: {
					borderColor: { base: 'transparent', _dark: '{colors.neutral.600}' },
				}
			}
		}
	}
});